// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"RunsTable_checkbox__ZAI4o","checkedCheckbox":"RunsTable_checkedCheckbox__1UuaI","sortingBox":"RunsTable_sortingBox__2Qiwk"};